import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function CategoryCard({ title, description, icon: Icon, to, stats }) {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      transition={{ duration: 0.2 }}
      className="bg-white rounded-[24px] border border-gray-150 p-6 flex flex-col justify-between shadow-sm hover:shadow-md transition-all duration-300 group"
    >
      <div>
        <div className="flex items-center justify-between gap-4 mb-4">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#7C3AED]/10 to-[#EC4899]/5 text-[#7C3AED] flex items-center justify-center group-hover:from-[#7C3AED] group-hover:to-[#EC4899] group-hover:text-white transition-all duration-300">
            {Icon && <Icon className="w-5 h-5" />}
          </div>
          {stats && (
            <span className="text-[10px] font-bold px-2.5 py-1 bg-indigo-50 text-indigo-600 rounded-full">
              {stats}
            </span>
          )}
        </div>

        <h3 className="font-display font-bold text-gray-950 text-lg leading-snug group-hover:text-[#7C3AED] transition-colors">
          {title}
        </h3>
        <p className="text-xs text-gray-500 mt-2 leading-relaxed">
          {description}
        </p>
      </div>

      <div className="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between">
        <Link
          to={to}
          className="text-xs font-bold text-[#7C3AED] hover:underline flex items-center gap-1 group-hover:translate-x-1 transition-transform"
        >
          Explore Section <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </motion.div>
  );
}
